import { Injectable } from '@angular/core';
import { PortalDictionary } from '../../models/portaldictionary.model';
import { PortalDictionaryComponent } from '../../models/portaldictionarycomponent.model';

@Injectable()
export class DictionaryService {
    public dictionaries: PortalDictionary[];

    //
    //constructor
    //
    constructor() {
    }

    //return the required Dictionary value for the given key (in the navigator.language)
    public getDictionaryValue(componentName: string = "", keyName: string = "", getShortText: boolean = false, defaultValue: string = ""): string {
        var value: string = defaultValue;
        var dict: PortalDictionary;
        var found: boolean = false;
        var browserlanguage: string = navigator.language;
        var dictionarylanguage: string;
        var tempValue: string = "";

        if ((this.dictionaries != null)
            && (componentName != null)
            && (componentName.trim().length > 0)
            && (keyName != null)
            && (keyName.trim().length > 0)) {

            for (dict of this.dictionaries) {
                dictionarylanguage = dict.defaultLanguage;

                var comp = dict.components.find(x => x.name == componentName);
                if ((comp != null)
                    && (comp.keys != null)
                    && (comp.keys.length > 0)) {

                    var key = comp.keys.find(x => x.name == keyName);
                    if ((key != null)
                        && (key.values != null)
                        && (key.values.length > 0)) {

                        if (browserlanguage.length > 0) {
                            var val = key.values.find(x => x.language == browserlanguage);
                            if (val != null) {
                                if (getShortText) {
                                    tempValue = val.shorttext;
                                }
                                else {
                                    tempValue = val.text;
                                }

                                if (tempValue.length > 0) {
                                    value = tempValue;
                                    found = true;
                                }
                            }
                        }

                        if ((found == false) 
                            && (dictionarylanguage.length > 0)) {
                            var val = key.values.find(x => x.language == dictionarylanguage);
                            if (val != null) {
                                if (getShortText) {
                                    tempValue = val.shorttext;
                                }
                                else {
                                    tempValue = val.text;
                                }

                                if (tempValue.length > 0) {
                                    value = tempValue;
                                    found = true;
                                }
                            }
                        }
                    }
                }

                if (found) {
                    break;
                }
            }
        }

        return value;
    }

    //return the given string with the {0}, {1},...  arguments replaces by the given function arguments
    public stringFormat(template: string, ...args: any[]) {
        return template.replace(/{(\d+)}/g, function (match, number) {
            return typeof args[number] != 'undefined' ? args[number] : match;
        });
    }

}